import { Search } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import './index.scss';


interface ISearchPrompt {
    searching: boolean,
    marginTop?: number
}

export const SearchPrompt: React.SFC<ISearchPrompt> = ({
    searching,
    marginTop,
    ...props }: ISearchPrompt) => {


    useEffect(() => {

    }, [searching])

    return (

        <Box textAlign="center" sx={{ opacity: .4, mt: marginTop ?? 10 }} >
            {searching ?
                <>
                    <CircularProgress />
                    <Typography color="primary" variant="subtitle2">Searching...</Typography>
                </>
                :
                <>
                    <Search color="primary" sx={{ fontSize: '4rem' }} />
                    <Typography color="primary" variant="subtitle2">Press <strong >Enter</strong> to begin search.</Typography>

                </>

            }
        </Box>

    );
}